import { connect } from 'react-redux';

import ThankYouModal from './thank-you';

import { closeModal } from '../../../reducers/userdata';

export default connect((state) => state, {
  closeModal,
})(ThankYouModal);
